import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import extraReducers from "../store/extraReducers";

import { type Customer, type UserDTO, initialCustomerState, parseCustomerDTO } from "@stepapp/core";
import { setSentryUser } from "@stepapp/sentry";
import { setIntercomUser } from "../services/Intercom";

const setUserContext = (user: Customer) => {
  if (user?.id && user?.email) {
    const { firstName, profile, email, lastName } = user;
    const username = `${firstName} ${lastName}`;
    setIntercomUser({
      email,
      name: username,
      phone: profile?.phoneNumber,
      signedUpAt: Date.now(),
      userId: email,
    });

    setSentryUser({
      email: user.email,
      username: `${user.firstName} ${user.lastName}`,
    });
  }
};

const userSlice = createSlice({
  name: "user",
  initialState: initialCustomerState,
  extraReducers: extraReducers(initialCustomerState),
  reducers: {
    setUserData: (_state, { payload }: PayloadAction<UserDTO>) => {
      const user = parseCustomerDTO(payload);
      setUserContext(user);
      return user;
    },
    editUserData: (state, { payload }: PayloadAction<Partial<Customer>>) => {
      const user = { ...state, ...payload };
      setUserContext(user);
      return user;
    },
    setUserVirtualWalletBalance: (state, { payload }: PayloadAction<number>) => {
      if (state.virtualWalletBalance) {
        state.virtualWalletBalance = payload;
      }
    },
  },
});

export const { setUserData, editUserData, setUserVirtualWalletBalance } = userSlice.actions;

export default userSlice.reducer;
